import React from "react";
const Loading=()=>{
  return(
    <div className="loadingDiv">
        <h1>Loading...</h1>
    </div>
  )
}
export default Loading